module.exports = __webpack_public_path__ + "media/images/logo-x-qr-3287afc0.svg";